import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { SparkMenu } from '../../ui/spark';
import LeftMainmenuItem from '../../helpers/LeftMainmenuItem';
import AppMenuConfig from '../../../config/Menu';
// eslint-disable-next-line import/named
import { modalGuestInfoActions } from '../../modals/AllModal';

class NavigateGeneral extends Component {
    componentDidMount() {
        this.menuInstance = new SparkMenu(this.node);
    }

    render() {
        const menuItems = AppMenuConfig.pages[this.props.route.menu];
        const { props } = this;
        return (
            <div>
                <div className="container">
                    <Link to={this.props.route.back}>
                        <div className="row">
                            <div className="col-md-2">
                                <i style={{ marginTop: 6 }} className="spark-icon-arrow-basic-left spark-icon--xd" />
                            </div>
                            <div className="col-md-10 link-to-home">Back</div>
                        </div>
                    </Link>
                </div>
                <LeftMainmenuItem icon="spark-icon-documents" title="GUEST & PAYMENT" copy="Standard 1 (STD1)" />
                <div className="spark-panel__content leftnav-menu-submenu-container">
                    <nav
                        ref={node => (this.node = node)}
                        className="spark-menu spark-menu--panel col-xs-12 col-col-md-12 col-lg-12 col-xl-12"
                    >
                        <ul className="spark-menu__list">
                            {menuItems.map((elm, i) => {
                                // workaround as the Spark FW sets a className "active" on the <li> elm
                                const active = `/pages/${elm.link}` === this.props.location.pathname;
                                const cssClassName = active ? 'spark-menu__list-item active' : 'spark-menu__list-item';
                                return (
                                    <li key={`item${i}`} className={cssClassName}>
                                        <Link activeClassName="active" className="spark-menu__list-link">
                                            {elm.name}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    modalSelectPropertyHelp: {
        show: () => dispatch(modalGuestInfoActions.show())
    }
});

NavigateGeneral.propTypes = {
    location: PropTypes.object
};

export default connect('', mapDispatchToProps)(NavigateGeneral);



// WEBPACK FOOTER //
// ./src/components/pages/pages/NavigateGeneral.js